import { EffectOptions } from '../app';
import { updateProductAccess } from '../app/state/app.actions';
import { AppActions } from '../app/state/app.types';
import { isFetchSuccessAction } from '../middleware';
import { USER_PROFILES_STATE_NAME } from './user-profiles.reducer';
import { selectHasProductAccess } from './user-profiles.selectors';

export function userProfilesEffects ({
    action, getState, dispatch
}: EffectOptions<AppActions>) {
    /**
     * When a user profile is loaded successfully we need to evaluate the business rules for product access.
     */
    if (isFetchSuccessAction(USER_PROFILES_STATE_NAME, action)) {
        // Use the data fetch action payload to determine access to the default product about to be loaded.
        const defaultProductId: number | null = action.payload?.data?.productLicenceContainer?.defaultProductId ?? null;
        const state = getState();
        const nextState = {
            ...state,
            userProfiles: {
                ...state.userProfiles,
                isSuccess: true,
                isLoading: false,
                data: action.payload.data
            }
        };
        const hasAccess = selectHasProductAccess(nextState, defaultProductId);

        dispatch(updateProductAccess(hasAccess));
    }
}
